module.exports = __webpack_public_path__ + "img/role-title-zh.afccd38a.png";